export default "__VITE_ASSET__DSXdAluD__"